import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';

class AuthDTO extends Serializable {

    @jsonProperty(String, null)
    user: string | null = '';

    @jsonProperty(String)
    password: string | null = '';
}

export default AuthDTO;


